// extracted by mini-css-extract-plugin
export default {"gift-cards-content":"SU1nSEj1CNTs6ImeN2xd","giftCardsContent":"SU1nSEj1CNTs6ImeN2xd","faq-content":"Ok2qgKDvYOgDNPFBBSbw","faqContent":"Ok2qgKDvYOgDNPFBBSbw"};